/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Refill_TitleInputs */

const es_admin_billing_last_refill_title = /** @type {(inputs: Admin_Billing_Last_Refill_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última recarga`)
};

const en_admin_billing_last_refill_title = /** @type {(inputs: Admin_Billing_Last_Refill_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last top-up`)
};

/**
* | output |
* | --- |
* | "Last top-up" |
*
* @param {Admin_Billing_Last_Refill_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_refill_title = /** @type {((inputs?: Admin_Billing_Last_Refill_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Refill_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_refill_title(inputs)
	return en_admin_billing_last_refill_title(inputs)
});
export { admin_billing_last_refill_title as "admin.billing.last_refill.title" }